"use client";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import image_1 from "@/Helper/images/homepageimg/Process monitoring.png";
import image_2 from "@/Helper/images/homepageimg/Loss Prevention.png";
import image_3 from "@/Helper/images/homepageimg/Safety-security.png";
import image_4 from "@/Helper/images/homepageimg/Operational efficiency.png";

import "@/app/page.css";

const Feature = () => {
  const [activeSection, setActiveSection] = useState(0);

  const handleSectionClick = (index) => {
    setActiveSection(index);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      const nextSection = (activeSection + 1) % 4;
      setActiveSection(nextSection);
    }, 5000);

    return () => clearTimeout(timeoutId);
  }, [activeSection]);

  return (
    <section className="container">
  <div className="featurelistpage  feature_container ">
    <h2 className="feature_subheading">
      Why Choose Visionfacts AI video analytics for businesses
    </h2>
    <p className="feature_content">
      We combine excellence with latest technologies to create remarkable
      solutions for different business verticals. Leveraging deep learning
      analytics that transforms businesses with AI implementation.
    </p>
  </div>
  <div className="featureBox_section">
    <div className="featureBox_left">
      <div
        className={`feature_left_card ${activeSection === 0 ? "active" : ""}`}
        onClick={() => handleSectionClick(0)}
      >
        <p className="heading">Process monitoring</p>
        <p className="subheading">
          It enables real-time process monitoring that allows facilities to
          automate monitoring seamlessly.
        </p>
      </div>
      <div
        className={`feature_left_card ${activeSection === 1 ? "active" : ""}`}
        onClick={() => handleSectionClick(1)}
      >
        <p className="heading">Loss Prevention</p>
        <p className="subheading">
          Avoid expenses of staff compensation with real-time detection of
          safety violations that can potentially lead to losses. It prevents
          accidents in the workplace resulting in loss prevention.
        </p>
      </div>
      <div
        className={`feature_left_card ${activeSection === 2 ? "active" : ""}`}
        onClick={() => handleSectionClick(2)}
      >
        <p className="heading">Safety & security</p>
        <p className="subheading">
          With computer vision AI, it became easier to keep track of the safety
          compliances and ensure workforce safety is contained without any
          violation.
        </p>
      </div>
      <div
        className={`feature_left_card ${activeSection === 3 ? "active" : ""}`}
        onClick={() => handleSectionClick(3)}
      >
        <p className="heading">Operational Efficiency</p>
        <p className="subheading">
          Artificial intelligence is at the forefront of all industries. It
          amplifies operational efficiency with valuable actionable insights.
        </p>
      </div>
    </div>
    <div className="featureBox_right">
      <div className="pic-holder">
        {activeSection === 0 ? (
          <Image
            src={image_1}
            className="pic"
            alt="Adept technology experts"
          />
        ) : activeSection === 1 ? (
          <Image
            src={image_2}
            className="pic"
            alt="State-of-the-art technology"
          />
        ) : activeSection === 2 ? (
          <Image
            src={image_3}
            className="pic"
            alt="Streamlined processes"
          />
        ) : activeSection === 3 ? (
          <Image
            src={image_4}
            className="pic"
            alt="Operational efficiency"
          />
        ) : null}
      </div>
    </div>
  </div>
</section>

  );
};

export default Feature;
